import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createEnrichedContext, deleteEnrichedContext, getEnrichedContext, queryEnrichedContexts, updateEnrichedContext } from '@wix/ambassador-individual-scheduling-assistant-v1-enriched-context/http';
import { createEnrichedContext as createClientEnrichedContext } from '@wix/ambassador-isa-digest-engine-v1-digest-engine/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { EnrichedContextClientBase } from './EnrichedContextClientBase';
export class EnrichedContextClient extends HttpBaseClient(EnrichedContextClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createEnrichedContextImpl", createEnrichedContext);
    _defineProperty(this, "getEnrichedContextImpl", getEnrichedContext);
    _defineProperty(this, "updateEnrichedContextImpl", updateEnrichedContext);
    _defineProperty(this, "deleteEnrichedContextImpl", deleteEnrichedContext);
    _defineProperty(this, "queryEnrichedContextsImpl", queryEnrichedContexts);
    _defineProperty(this, "createClientEnrichedContextImpl", createClientEnrichedContext);
  }
}
//# sourceMappingURL=EnrichedContextClientHttp.js.map